import throttle from 'lodash/throttle'
import Supercluster from 'supercluster'
import { ref, watch } from 'vue'

export const usePointCluster = () => {
  let index = null
  const sourceGeojson = ref(null)
  const clusterGeojson = ref({})
  const zoomLevel = ref(0)

  const makeClusterGeojson = (clusters) => {
    const geoJson = {
      type: 'FeatureCollection',
      features: clusters.map((cluster) => {
        const feature = {
          type: 'Feature',
          properties: {
            ...cluster.properties
          },
          geometry: {
            type: 'Point',
            coordinates: cluster.geometry?.coordinates
          }
        }
        return feature
      })
    }
    return geoJson
  }

  watch(sourceGeojson, () => {
    if (!sourceGeojson.value) return
    if (!zoomLevel.value) return
    index = new Supercluster({
      radius: 12,
      map: (props) => props,
      reduce: (accumulated, props) => {
        const isFirstItem = accumulated === null
        if (!isFirstItem) {
          return accumulated
        }
        return props
      }
    })
    index.load(sourceGeojson.value.features)
    const clusters = index.getClusters([-180, -90, 180, 90], zoomLevel.value)
    clusterGeojson.value = makeClusterGeojson(clusters)
  })

  const updateZoomLevel = throttle((newValue) => {
    if (!sourceGeojson.value) return
    if (!index) return
    const clusters = index.getClusters([-180, -90, 180, 90], newValue)
    clusterGeojson.value = makeClusterGeojson(clusters)
  }, 100)

  watch(zoomLevel, (newValue, oldValue) => {
    if (!sourceGeojson.value) return
    if (!index) return
    if (Math.round(newValue) === Math.round(oldValue)) return
    updateZoomLevel(newValue, oldValue)
  })

  return {
    sourceGeojson,
    clusterGeojson,
    zoomLevel
  }
}
